import { Injectable } from '@angular/core';

//
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// models
import { ParticipantSetting } from "../models/participant-setting";

// config
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ParticipantSettingService {

    /**
       * constructor
       *
       * @param jwtHttp
       */
    constructor(
        private http: HttpClient,
    ) { }

    /**
     * get global settings for the current user
     *
     * @return {Observable<any>}
     */
    public getGlobal(): Observable<any> {
        return this.http.get(environment.api + '/participant-settings/global');
    }

    /**
     * get event based settings for the current user
     *
     * @return {Observable<any>}
     */
    public getByEvent(id: number): Observable<any> {
        return this.http.get(environment.api + '/participant-settings/event/' + id);
    }

    /**
     * create settings
     *
     * @param settings
     *
     * @return {Observable<any>}
     */
    public create(settings: ParticipantSetting): Observable<any> {
        return this.http.post(environment.api + '/participant-settings', settings);
    }

    /**
     * update settings
     *
     * @param settings
     *
     * @return {Observable<any>}
     */
    public update(settings: ParticipantSetting): Observable<any> {
        return this.http.put(environment.api + '/participant-settings/' + settings.id, settings);
    }

    /**
     * get mail settings
     *
     * @param participantId
     *
     * @return {Observable<any>}
     */
    public getMailSetting(participantId: number, token: string): Observable<any> {
        return this.http.get(environment.api + '/participant/' + participantId + '/mail-setting', {
            params: {
                mailToken: token
            }
        });
    }

    /**
    * set mail settings
    *
    * @param settings
    *
    * @return {Observable<any>}
    */
    public setMailSetting(participantId: number, token: string, src: string, srcId: number, setting: ParticipantSetting): Observable<any> {
        return this.http.put(environment.api + '/participant/' + participantId + '/mail-setting', setting, {
            params: {
                mailToken: token,
                src: src,
                srcId: srcId
            }
        });
    }

    /**
    * unsubscribe from invitation
    *
    * @param participantId
    * @param token
    * @param src
    * @param srcId
    * @param reason
    *
    * @return {Observable<any>}
    */
    public unsubscribe(participantId: number, token: string, src: string, srcId: number, reason: string = ''): Observable<any> {
        return this.http.get(environment.api + '/participant/' + participantId + '/mail-unsubscribe', {
            params: {
                token: token,
                src: src,
                srcId: srcId,
                reason: reason,
                appRequest: true
            }
        });
    }
}
